export const environment = {
  production: false,
  groupName: '--',
  apiUrl: 'https://nmadoaapp-api-test.azure.chevron.com/api',
  scope: 'https://nmadoa-dev.azure.chevron.com/user_impersonation',
};
